export {
  Pictogram,
  type PictogramProps,
  type PictogramName,
} from '@tui-cruises/mein-schiff-web-react-component-library/src/components/core/Pictogram';
